import { getContext, put, takeEvery } from 'redux-saga/effects';
import { SupabaseClient } from '@supabase/supabase-js';
import { userLogoutButtonClicked } from '@wix/da-shared-react/pkg/SiteHeader/redux/actions';
import { setCompliantLocalStorageItem } from '@wix/da-react-context/pkg/compliantLocalStorage/redux/actions';
import { CompliantLocalStorageKeys } from '@wix/da-react-context/pkg/compliantLocalStorage/redux/constants';
import ddt from '@wix/da-ddt';
import { Database } from '@wix/da-papi-types/lib/supabase';

function* handleUserLogout() {
  try {
    const client: SupabaseClient<Database, 'damz'> = yield getContext('supaClient');

    // Sign out from Supabase
    const { error } = yield client.auth.signOut();
    if (error) {
      ddt.error('damz', 'Failed to sign out from Supabase', error);
    } else {
      ddt.log('damz', 'Successfully signed out from Supabase');
    }

    // Delete damztoken cookie
    document.cookie = 'damztoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    ddt.log('damz', 'Deleted damztoken cookie');

    // Clear localStorage by setting empty damz state
    yield put(
      setCompliantLocalStorageItem({
        key: CompliantLocalStorageKeys.CHATDB,
        value: JSON.stringify({}),
      })
    );
    ddt.log('damz', 'Cleared damz localStorage data');
  } catch (error) {
    ddt.error('damz', 'Error during logout cleanup', error);
  }
}

export function* logoutSaga() {
  yield takeEvery(userLogoutButtonClicked, handleUserLogout);
}
